import {EventEmitter} from "@/utils/event-emitter";
import {Crm} from "@/models/base";
import CrmHistory from "@/models/crm/crm-history";
import {CrmService} from "@/services";

export class CrmEditState extends EventEmitter {
	public crm: Crm = new Crm();
	public deleteHistoryEvent(event:CrmHistory){
		this.crm.History = this.crm.History.filter(item => item.ID !== event.ID);
	}
	public async fetch(){
		if(!this.crm.ID){
			return;
		}
		this.crm = await CrmService.get(this.crm.ID);
	}

}